import type { URLParams } from '../../types';

export class UrlParamService {
  static parseUrlParams(): URLParams {
    const params = new URLSearchParams(window.location.search);
    return {
      userId: params.get('userId') || undefined,
      referralCode: params.get('referralCode') || undefined,
      surveyId: params.get('surveyId') || undefined,
      anonymous: params.get('anonymous')?.toLowerCase() === 'true',
      emailAddress: params.get('emailAddress') || undefined,
      source: params.get('source') || undefined,
    };
  }
}
